import { produce } from "immer";
import Actions from "../actions";

const initialState = {
    users: {},
    serviceProviders: {}
};


const chatAccess = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_CHAT_ACCESS_USER_LIST: {
      draft.users = payload?.users;
      break;
    }
    case Actions.GET_CHAT_ACCESS_SERVICE_PROVIDER_LIST: {
      draft.serviceProviders = payload?.serviceProviders;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default chatAccess;
